/* Summit Animal Health · Dog Week sale page behaviour (v4).
   Everything lives under .sld-page .pw-*; add-to-cart posts to /cart/add.js on the
   store and is mocked (state only) when the page is served outside Shopify. */
(function () {
  'use strict';
  if (window.__pwInit) return; window.__pwInit = true;

  var ON_SHOPIFY = /summitanimalhealth|myshopify/.test(location.hostname);
  function money(n) { return '$' + n.toFixed(2); }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }


  /* Announcement bar: this page sells one-time purchases only, so drop the subscriptions half of the theme's global line (Marcell, 2026-09-12) */
  (function () {
    function trim() { document.querySelectorAll('#shopify-section-notifications .slider-slide p').forEach(function (p) { var t = p.textContent; if (t.indexOf('|') > -1) p.textContent = t.split('|')[0].trim(); }); }
    trim(); if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', trim); window.addEventListener('load', trim);
  })();
  /* ---------- pet picker + buy box ---------- */
  var PETS = window.PW_PETS || {};
  (function () { var el = document.querySelector('script[data-pw-pets]'); if (el && !window.PW_PETS) { try { PETS = window.PW_PETS = JSON.parse(el.textContent); } catch (e) {} } })();
  function initPicker(box) {
    if (!box || box.dataset.pwReady) return; box.dataset.pwReady = '1';
    var pills = box.querySelectorAll('[data-pw-pet]');
    /* add-on tick boxes (Dental, Hot Spots): each carries its variant, regular price, the pets it applies to and a short label for the sticky bar */
    var bumps = Array.prototype.slice.call(box.querySelectorAll('[data-pw-bump]')).map(function (el) {
      return { el: el, cb: el.querySelector('[data-pw-bump-cb]'), variant: el.dataset.variant || '', unit: parseFloat(el.dataset.unit) || 0,
        pets: (el.dataset.pets || 'small,medium,large').split(','), label: el.dataset.label || 'Dental' };
    });
    function bumpOn(b) { return !!(b.cb && b.cb.checked && !b.el.hidden); }
    var stickyEl = document.querySelector('[data-pw-sticky]');
    var qtys = box.querySelectorAll('[data-pw-qty]');
    var img = box.querySelector('[data-pw-img]');
    var thumbs = box.querySelectorAll('[data-pw-thumb]');
    var name = box.querySelector('[data-pw-name]');
    var forEl = box.querySelector('[data-pw-for]');
    var rating = box.querySelector('[data-pw-rating]');
    var rcount = box.querySelector('[data-pw-rcount]');
    var was = box.querySelector('.sld-price__was'), now = box.querySelector('.sld-price__now'),
        save = box.querySelector('.sld-price__save'), dose = box.querySelector('.sld-price__day');
    var addBtn = box.querySelector('[data-pw-add]');
    var input = box.querySelector('[data-pw-q]');
    var dec = box.querySelector('[data-pw-dec]'), inc = box.querySelector('[data-pw-inc]');
    var revB = box.querySelector('[data-pw-rev-b]'), revBy = box.querySelector('[data-pw-rev-by]');
    var added = box.querySelector('[data-pw-added]');
    var state = { pet: box.dataset.pet || 'medium', qty: box.dataset.qtyKey || 'starter' };

    function paint() {
      var p = PETS[state.pet]; if (!p) return;
      var o = p[state.qty];
      var q = input ? (parseInt(input.value, 10) || 1) : 1;
      if (img) {
        var frontThumb = box.querySelector('[data-pw-thumb][data-role="front"]');
        var backThumb = box.querySelector('[data-pw-thumb][data-role="back"]');
        var onThumb = box.querySelector('[data-pw-thumb].sld-is-on');
        if (frontThumb) { frontThumb.dataset.src = p.img; frontThumb.querySelector('img').src = p.img; }
        if (backThumb) { backThumb.dataset.src = p.back; backThumb.querySelector('img').src = p.back; }
        var lifeThumb = box.querySelector('[data-pw-thumb][data-role="life"]');
        if (lifeThumb && p.life) { lifeThumb.dataset.src = p.life; var li = lifeThumb.querySelector('img'); li.src = p.life; li.alt = p.lifeAlt || ''; }
        var role = onThumb ? onThumb.dataset.role : 'front';
        img.src = role === 'back' ? p.back : (role === 'life' && p.life ? p.life : p.img);
        img.alt = role === 'life' && p.lifeAlt ? p.lifeAlt : p.name;
      }
      if (name) name.textContent = p.name;
      if (forEl) { forEl.textContent = p.who; forEl.classList.toggle('pw-tag--cat', state.pet === 'cat'); }
      if (rating) rating.textContent = p.rating;
      if (rcount) rcount.textContent = p.reviews;
      var price = o.was;
      if (now) now.textContent = money(price);
      if (dose) dose.textContent = money(price / o.doses) + ' a dose · ' + o.doses + ' doses';
      qtys.forEach(function (b) {
        var k = b.dataset.pwQty, oo = p[k];
        b.classList.toggle('pw-is-on', k === state.qty);
        var w = b.querySelector('[data-pw-qty-price]'); if (w && oo) w.textContent = money(oo.was);
      });
      if (revB) revB.textContent = p.review.b; if (revBy) revBy.textContent = p.review.by;
      box.dataset.variant = o.variant; box.dataset.unit = price;
      var extra = 0, extraLabels = [];
      bumps.forEach(function (b) {
        var off = b.pets.indexOf(state.pet) < 0; b.el.hidden = off; if (off && b.cb) b.cb.checked = false;
        b.el.classList.toggle('pw-is-on', bumpOn(b)); if (bumpOn(b)) { extra += b.unit; extraLabels.push(b.label); }
      });
      var withDental = extraLabels.length > 0;
      var total = price * q + extra;
      if (addBtn && !addBtn.dataset.busy) addBtn.textContent = 'Add ' + (q > 1 ? q + ' ' : '') + 'to cart' + (window.innerWidth > 560 ? ' · ' + money(total) : ''); /* phones: price sits right above the button */
      if (dec) dec.disabled = q <= 1;
      if (stickyEl) {
        var st = stickyEl.querySelector('[data-pw-sticky-title]'), ss = stickyEl.querySelector('[data-pw-sticky-sub]'), si = stickyEl.querySelector('[data-pw-sticky-img]');
        stickyEl.__pwTitle = p.short + ' · ' + money(total);
        var narrow = window.innerWidth <= 560; /* phones: keep the code from clipping in the one-line sticky sub */
        stickyEl.__pwSub = (state.qty === 'starter' ? (narrow ? 'Starter Pack' : '2-Box Starter Pack') : 'Single Box') + (withDental ? ' + ' + extraLabels.join(' + ') : '');
        stickyEl.__pwImg = p.img;
        if (!stickyEl.classList.contains('pw-is-before')) { if (st) st.textContent = stickyEl.__pwTitle; if (ss) ss.textContent = stickyEl.__pwSub; if (si) si.src = p.img; }
      }
      if (added) added.classList.remove('pw-is-on');
    }
    box.__pwItems = function () {
      var q = input ? (parseInt(input.value, 10) || 1) : 1; var items = [{ id: Number(box.dataset.variant), quantity: q }];
      bumps.forEach(function (b) { if (bumpOn(b)) items.push({ id: Number(b.variant), quantity: 1 }); });
      return items;
    };
    box.__pwAdd = function (btn) { addToCart(box, btn, box.__pwItems, added); };
    bumps.forEach(function (b) { if (b.cb) b.cb.addEventListener('change', paint); });
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(paint, 120); });
    pills.forEach(function (b) {
      b.addEventListener('click', function () {
        pills.forEach(function (x) { x.classList.remove('pw-is-on'); x.setAttribute('aria-pressed', 'false'); });
        b.classList.add('pw-is-on'); b.setAttribute('aria-pressed', 'true');
        state.pet = b.dataset.pwPet; paint();
      });
    });
    qtys.forEach(function (b) { b.addEventListener('click', function () { state.qty = b.dataset.pwQty; paint(); }); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { thumbs.forEach(function (o) { o.classList.remove('sld-is-on'); }); t.classList.add('sld-is-on'); if (img) { img.src = t.dataset.src; var ti = t.querySelector('img'); img.alt = ti && ti.alt ? ti.alt : img.alt; } }); });
    if (dec) dec.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); paint(); });
    if (inc) inc.addEventListener('click', function () { input.value = Math.min(99, (parseInt(input.value, 10) || 1) + 1); paint(); });
    if (input) input.addEventListener('change', paint);
    if (addBtn) addBtn.addEventListener('click', function () { box.__pwAdd(addBtn); });
    paint();
  }

  /* ---------- add-on card (Dental) ---------- */
  function initAddon(card) {
    if (!card || card.dataset.pwReady) return; card.dataset.pwReady = '1';
    var addBtn = card.querySelector('[data-pw-add]'); var added = card.querySelector('[data-pw-added]');
    var input = card.querySelector('[data-pw-q]'); var dec = card.querySelector('[data-pw-dec]'), inc = card.querySelector('[data-pw-inc]');
    function paint() { var q = input ? (parseInt(input.value, 10) || 1) : 1; if (dec) dec.disabled = q <= 1; if (addBtn && !addBtn.dataset.busy) addBtn.textContent = card.hasAttribute('data-pw-noprice') ? ('Add ' + (q > 1 ? q + ' ' : '') + 'to cart') : ('Add ' + (q > 1 ? q + ' ' : '') + 'to cart · ' + money(parseFloat(card.dataset.unit) * q)); }
    if (dec) dec.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); paint(); });
    if (inc) inc.addEventListener('click', function () { input.value = Math.min(99, (parseInt(input.value, 10) || 1) + 1); paint(); });
    if (input) input.addEventListener('change', paint);
    if (addBtn) addBtn.addEventListener('click', function () { addToCart(card, addBtn, function () { return [{ id: Number(card.dataset.variant), quantity: parseInt(input.value, 10) || 1 }]; }, added); });
    paint();
  }

  function addToCart(box, btn, itemsFn, added) {
    var items = itemsFn ? itemsFn() : [{ id: Number(box.dataset.variant), quantity: 1 }]; if (!items.length || !items[0].id) return;
    var original = btn.textContent; btn.dataset.busy = '1'; btn.disabled = true; btn.textContent = 'Adding…';
    function done(ok, msg) {
      btn.disabled = false; delete btn.dataset.busy; btn.textContent = ok ? original : (msg || 'Could not add to cart');
      if (ok && added) added.classList.add('pw-is-on');
      if (!ok) setTimeout(function () { btn.textContent = original; }, 3200);
      if (ok) { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true })); var op = document.querySelector('[data-sld-cart-open]'); if (op) op.click(); }
    }
    if (!ON_SHOPIFY) { setTimeout(function () { done(true); }, 500); return; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.status) done(false, (d.description || '').length > 40 ? null : d.description); else done(true); })
      .catch(function () { done(false); });
  }

  /* ---------- code chip (same behaviour as the live sld-code) ---------- */
  function initCode(chip) {
    if (chip.dataset.pwReady) return; chip.dataset.pwReady = '1';
    var btn = chip.querySelector('.sld-code__cp') || chip.querySelector('button'); var code = chip.dataset.code || (chip.querySelector('.sld-code__val') || {}).textContent || '';
    if (!btn) return;
    var label = btn.textContent;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      function ok() { chip.classList.add('pw-is-copied'); btn.textContent = 'Copied'; setTimeout(function () { chip.classList.remove('pw-is-copied'); btn.textContent = label; }, 2200); }
      function fallback() { var ta = document.createElement('textarea'); ta.value = code; ta.style.position = 'fixed'; ta.style.opacity = '0'; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); ok(); } catch (err) {} document.body.removeChild(ta); }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(ok, fallback); else fallback();
    });
  }

  /* ---------- countdown ---------- */
  function initCountdown(el) {
    if (el.dataset.pwReady) return; el.dataset.pwReady = '1';
    var end = Date.parse(el.dataset.pwEnd); if (isNaN(end)) return;
    var start = Date.parse(el.dataset.pwStart || ''); var compact = el.hasAttribute('data-pw-compact');
    var lbl = el.parentElement ? el.parentElement.querySelector('[data-pw-cdlbl]') : null;
    var D = el.querySelector('[data-d]'), H = el.querySelector('[data-h]'), M = el.querySelector('[data-m]'), S = el.querySelector('[data-s]');
    var ended = el.dataset.pwEnded || 'This sale has ended';
    var timer;
    function tick() {
      var t = Date.now();
      /* always count to the END: the page is only reached through ads once the sale is live (Marcell 9/9), so a 'starts in' state is never seen by a customer */
      var pre = false; var target = end; var label = pre ? (el.dataset.pwPrelabel || 'Sale starts in') : (el.dataset.pwLabel || 'Sale ends in');
      if (lbl) { if (!lbl.dataset.pwLive) lbl.dataset.pwLive = lbl.innerHTML; var want = pre ? (lbl.dataset.pwPre || lbl.dataset.pwLive) : lbl.dataset.pwLive; if (lbl.innerHTML !== want) lbl.innerHTML = want; }
      if (t >= end) { if (compact) el.textContent = ended; else if (D) { D.textContent = H.textContent = M.textContent = S.textContent = '00'; } clearInterval(timer); return; }
      var d = target - t, dd = Math.floor(d / 864e5), hh = Math.floor(d % 864e5 / 36e5), mm = Math.floor(d % 36e5 / 6e4), ss = Math.floor(d % 6e4 / 1e3);
      if (compact) el.textContent = label + ' ' + dd + 'd ' + pad(hh) + 'h ' + pad(mm) + 'm';
      else if (D) { D.textContent = pad(dd); H.textContent = pad(hh); M.textContent = pad(mm); S.textContent = pad(ss); }
    }
    tick(); timer = setInterval(tick, 1000);
  }

  /* ---------- FAQ (Labor Day markup: .sld-faq__i / .sld-faq__q, state class is-open) ---------- */
  function initFaq(root) {
    root.querySelectorAll('.sld-faq__q').forEach(function (q) {
      if (q.dataset.pwReady) return; q.dataset.pwReady = '1';
      q.addEventListener('click', function () { var open = q.parentElement.classList.toggle('is-open'); q.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    });
  }

  /* ---------- Danny & Ron media: photo with play button, two clips swap in place ---------- */
  function initDr(wrap) {
    if (wrap.dataset.pwReady) return; wrap.dataset.pwReady = '1';
    var media = wrap.querySelector('[data-pw-dr-media]'); var v = media && media.querySelector('video'); if (!v) return;
    var play = media.querySelector('.pw-play'); var clips = wrap.querySelectorAll('[data-pw-clip]');
    function load(btn) {
      clips.forEach(function (c) { c.classList.toggle('pw-is-on', c === btn); c.setAttribute('aria-pressed', c === btn ? 'true' : 'false'); });
      if (v.getAttribute('src') !== btn.dataset.src) { v.setAttribute('src', btn.dataset.src); v.load(); }
      if (play) { var b = play.querySelector('b'); if (b) b.textContent = btn.dataset.label; var s = play.querySelector('small'); if (s) s.textContent = btn.dataset.sub; }
      media.classList.toggle('pw-is-vert', btn.dataset.orient === 'vert');
    }
    function start() { media.classList.add('pw-is-playing'); v.controls = true; v.muted = false; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    if (play) play.addEventListener('click', start);
    clips.forEach(function (c) { c.addEventListener('click', function () { load(c); start(); }); });
    v.addEventListener('ended', function () { media.classList.remove('pw-is-playing'); v.controls = false; try { v.currentTime = 0; } catch (e) {} });
    var first = wrap.querySelector('[data-pw-clip].pw-is-on') || clips[0]; if (first) load(first);
  }

  /* ---------- sticky bar (mobile) ---------- */
  (function () {
    /* Ad and email traffic arrives via /discount/WOOF20, which sets Shopify's discount_code cookie: say so after the add */
    if (!/(^|; )discount_code=[^;]+/.test(document.cookie)) return;
    document.querySelectorAll('[data-pw-added][data-pw-added-applied]').forEach(function (el) { el.innerHTML = el.getAttribute('data-pw-added-applied'); });
  })();
  function initSticky(bar) {
    if (bar.dataset.pwReady) return; bar.dataset.pwReady = '1';
    var hero = document.querySelector('.pw-hero'); var box = document.querySelector('[data-pw-box]'); var disc = document.querySelector('.pw-disc');
    var atc = box ? box.querySelector('[data-pw-add]') : null; if (!atc) return;
    var atcs = Array.prototype.slice.call(document.querySelectorAll('[data-pw-add]')); var picker = document.querySelector('#pw-pick') || box.querySelector('.pw-pets');
    var st = bar.querySelector('[data-pw-sticky-title]'), ss = bar.querySelector('[data-pw-sticky-sub]'), si = bar.querySelector('[data-pw-sticky-img]');
    var addBtn = bar.querySelector('[data-pw-sticky-add]'); var addedMsg = box.querySelector('[data-pw-added]');
    var mode = null;
    function setMode(m) {
      if (m === mode) return; mode = m;
      bar.classList.toggle('pw-is-on', m !== 'off');
      bar.classList.toggle('pw-is-before', m === 'before');
      if (m === 'before') { if (st) st.textContent = bar.dataset.pwBeforeTitle || ''; if (ss) ss.textContent = bar.dataset.pwBeforeSub || ''; }
      else if (m === 'after') { if (st && bar.__pwTitle) st.textContent = bar.__pwTitle; if (ss && bar.__pwSub) ss.textContent = bar.__pwSub; if (si && bar.__pwImg) si.src = bar.__pwImg; }
    }
    function update() {
      var vh = window.innerHeight;
      var h = hero ? hero.getBoundingClientRect() : null; var a = atc.getBoundingClientRect(); var d = disc ? disc.getBoundingClientRect() : null;
      var heroIn = h && h.bottom > 0; var discIn = d && d.top < vh;
      var atcIn = atcs.some(function (b) { var r = b.getBoundingClientRect(); return r.width > 0 && r.bottom > 0 && r.top < vh - 60; });
      var pk = picker ? picker.getBoundingClientRect() : null; var pickerIn = pk && pk.bottom > 0 && pk.top < vh - 60;
      var bx = box.getBoundingClientRect();
      if (heroIn || atcIn || pickerIn || discIn) setMode('off'); else setMode(bx.top >= vh - 80 ? 'before' : 'after');
    }
    /* no requestAnimationFrame here: a background tab never runs the frame, which left the bar stuck hidden */
    var last = 0;
    function onScroll() { var now = Date.now(); if (now - last < 40) { clearTimeout(bar.__t); bar.__t = setTimeout(update, 50); return; } last = now; update(); }
    window.addEventListener('scroll', onScroll, { passive: true }); window.addEventListener('resize', onScroll);
    document.addEventListener('visibilitychange', update); window.addEventListener('pageshow', update); window.addEventListener('load', update);
    if (addBtn) addBtn.addEventListener('click', function () { if (box.__pwAdd) box.__pwAdd(addBtn); });
    update();
  }

  /* ---------- anchors (offset for the theme's fixed header) ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('.sld-page a[href^="#pw-"]') : null; if (!a) return;
    var target = document.getElementById(a.getAttribute('href').slice(1)); if (!target) return;
    e.preventDefault(); var header = document.querySelector('.main-header-wrapper'); var off = header ? header.getBoundingClientRect().height : 0;
    window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - off - 8, behavior: 'smooth' });
  });

  function boot(root) {
    root = root || document;
    root.querySelectorAll('[data-pw-box]').forEach(initPicker);
    root.querySelectorAll('[data-pw-addon]').forEach(initAddon);
    root.querySelectorAll('.sld-code').forEach(initCode);
    root.querySelectorAll('[data-pw-countdown]').forEach(initCountdown);
    root.querySelectorAll('.pw-faq').forEach(initFaq);
    root.querySelectorAll('[data-pw-dr]').forEach(initDr);
    root.querySelectorAll('.pw-sticky').forEach(initSticky);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
